import React, { useState, useEffect } from 'react';
import { ThemeProvider, CssBaseline } from '@mui/material';
import Login from './components/Login';
import LoginSelector from './components/LoginSelector';
import ParentLogin from './modules/parent/ParentLogin';
import ParentDashboard from './modules/parent/ParentDashboard';
import SchoolDashboard from './modules/school/SchoolDashboard';
import AgencyDashboard from './components/AgencyDashboard';
import SuperAdminDashboard from './modules/admin/SuperAdminDashboard';
import TeacherDashboard from './modules/teacher/TeacherDashboard';
import SimpleTestApp from './SimpleTestApp';
import api from './services/api';
import portalTheme from './styles/portalMuiTheme';
import './styles/portalTheme.css';
import './App.css';

function App() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const handleUserLogin = (event) => {
      setUser(event.detail);
    };

    window.addEventListener('userLogin', handleUserLogin);
    return () => window.removeEventListener('userLogin', handleUserLogin);
  }, []);

  const handleLogin = (userData) => {
    setUser(userData);
  };

  const handleLogout = async () => {
    await api.logout();
    setUser(null);
  };

  const renderDashboard = () => {
    switch (user.role) {
      case 'parent':
        return <ParentDashboard user={user} onLogout={handleLogout} />;
      case 'school':
        return <SchoolDashboard user={user} onLogout={handleLogout} />;
      case 'teacher':
        return <TeacherDashboard user={user} onLogout={handleLogout} />;
      case 'agency':
        return <AgencyDashboard user={user} onLogout={handleLogout} />;
      case 'admin':
        return <SuperAdminDashboard user={user} onLogout={handleLogout} />;
      default:
        return <Login />;
    }
  };

  const isTestMode = window.location.pathname === '/test' || window.location.search.includes('test=true');

  if (isTestMode) {
    return <SimpleTestApp />;
  }

  const getLoginComponent = () => {
    const path = window.location.pathname;
    if (path === '/parent') {
      return <ParentLogin onLogin={handleLogin} />;
    } else if (path === '/school' || path === '/teacher') {
      return <Login />;
    } else if (path === '/admin') {
      return <Login />;
    } else if (path === '/agency') {
      return <Login />;
    } else if (path === '/') {
      return <LoginSelector />;
    }
    return <LoginSelector />;
  };

  return (
    <ThemeProvider theme={portalTheme}>
      <CssBaseline />
      <div className="App">
        {user ? renderDashboard() : getLoginComponent()}
      </div>
    </ThemeProvider>
  );
}

export default App;
